/**
 * CBE SuperApp + CBE Birr Plus payment API config.
 */

/** Qetero API base (no trailing slash) */
export const PAY_API_URL = "https://qetero.com/api"

/** Full create-payment endpoint used for CBE SuperApp and CBE Birr Plus */
export const CBE_CREATE_PAYMENT_URL = `${PAY_API_URL}/v1/payments/createChechePayment`

/** Mini App short code (CBE SuperApp) */
export const CBE_APP_CODE = "VDvnRRYn"

/** Cheche payment method id — CBE SuperApp */
export const CBE_CREATE_ORDER_ID = "638937b4-befb-424f-868e-aa0b3181233e"

/** Cheche payment method id — CBE Birr Plus (vendor_type CBE) */
export const CBE_BIRR_PLUS_PAYMENT_METHOD_ID =
  import.meta.env.VITE_CBE_BIRR_PLUS_PAYMENT_METHOD_ID ||
  import.meta.env.NEXT_PUBLIC_CBE_BIRR_PLUS_PAYMENT_METHOD_ID ||
  "ddf74ea5-ee74-49e5-afbd-62a68bcd88d9"
